/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, useSelector } from 'react-redux';
import { Row, Col, Accordion } from 'react-bootstrap';
import { cloneDeep } from 'lodash';
import { useTranslation } from 'react-i18next';
import { getHideShowGrading, updateMeasurementSuggestion, unlinkUploadImage } from '../../store/SupplierSuggestion.action';
import SpecPomLibraries from './SpecPomLibraries/SpecPomLibraries';
import { checkArray } from '../../../../Components/helper';
import { calculatePreviousSize, calculationSampleSize } from '../../../DevlopmentOrder/Measurment/Components/Calculation';

export const MeasurementDataProvider = React.createContext({});

function MeasurementForm({ conversationData, measurementSuggestion, unlinkUploadImage, showGrading }) {
  const [uploadedImg, setUploadedImg] = useState([]);
  const { t } = useTranslation('common');
  const {
    origanalMeasurmentData,
    pomLibrariesFields,
    pomLibrariesAppend,
    pomLibrariesRemove,

    specPomLibrariesFields,
    specPomLibrariesAppend,
    specPomLibrarieRemove,
    specPomUpdateLibraries,
    setValue,
    measurementEditMode,
    editedPomLibraries,
    editedSpecPomLibraries,
    oldMeasurmentData,
  } = useFormContext(); // retrieve all hook methods

  const [comState, setState] = useState({
    accodionArray: ['cadFile', 'otherFile'],
    editModeData: [],
  });
  const {
    UserDetails: { userInfo },
  } = useSelector((reduxState) => reduxState);
  const { gradingFormat } = userInfo;

  const [isLoadingSpecPomLib, setIsLoadingSpecPomLib] = useState(false);
  const [sugFracData, setSugFracData] = useState([]);
  const [sugPomFracData, setSugPomFracData] = useState({});
  const [sugSpecPomFracData, setSugSpecPomFracData] = useState({});
  const [origanalMeasurmentDataObj, setOriganalMeasurmentDataObj] = useState({});

  useEffect(() => {
    const setData = async () => {
      if (conversationData) {
        setSugFracData({
          ...origanalMeasurmentDataObj,
          pomLibraries: measurementSuggestion[0]?.pomLibraries,
          specPomLibraries: measurementSuggestion[0]?.specPomLibraries,
        });
        await setSugSpecPomFracData({
          ...origanalMeasurmentData[0],
          specPomLibraries: measurementSuggestion[0]?.specPomLibraries,
        });
        setOriganalMeasurmentDataObj({ ...origanalMeasurmentData[0] });
      }
    };
    setData();
  }, [measurementSuggestion, conversationData]);

  useEffect(() => {
    const setData = async () => {
      await pomLibrariesRemove();
      if (oldMeasurmentData && editedPomLibraries && sugPomFracData.pomLibraries && measurementEditMode && pomLibrariesFields.length === 0) {
        const oldPomDataArr = oldMeasurmentData[0].pomLibraries;
        const specPomLibDataArry = sugPomFracData.pomLibraries.map((item) => {
          const oldData = Array.isArray(oldPomDataArr) && oldPomDataArr.filter((e) => e.code === item.code);

          if (oldData?.length === 0 && item.status !== 'Approved') {
            return {
              ...item,
              status: 'Deleted',
            };
          }
          return {
            ...item,
          };
        });
        await pomLibrariesAppend([...specPomLibDataArry]);
      }
    };
    setData();
  }, [editedPomLibraries]);

  useEffect(() => {
    const setData = async () => {
      if (checkArray(oldMeasurmentData) && editedSpecPomLibraries && sugSpecPomFracData.specPomLibraries && measurementEditMode) {
        setIsLoadingSpecPomLib(true);
        const oldSpecDataArr = oldMeasurmentData[0].specPomLibraries;

        const specPomLibDataArry = sugSpecPomFracData.specPomLibraries.map((item) => {
          const oldData = Array.isArray(oldSpecDataArr) && oldSpecDataArr.filter((e) => e.code === item.code);

          if (oldData?.length === 0 && item.status !== 'Approved') {
            return {
              ...item,
              status: 'Deleted',
            };
          }
          return {
            ...item,
          };
        });

        setState((prevState) => ({
          ...prevState,
          editModeData: specPomLibDataArry,
        }));
        await specPomLibrariesAppend([...specPomLibDataArry]);
        setIsLoadingSpecPomLib(false);
      }
    };
    setData();
  }, [editedSpecPomLibraries]);

  // calculation added for sample size & previous size
  const findFractionDiff = async (parentIndex) => {
    const tmpPomFields = cloneDeep(specPomLibrariesFields);
    const mesurePoms = tmpPomFields[parentIndex];
    const mainSuggestionData = cloneDeep(sugFracData);

    if (gradingFormat === 'sample') {
      const finalSampleData = await calculationSampleSize(mesurePoms, mainSuggestionData?.specPomLibraries[parentIndex]);
      tmpPomFields[parentIndex] = finalSampleData;
    } else {
      calculatePreviousSize(mesurePoms, mainSuggestionData?.specPomLibraries[parentIndex]);
      tmpPomFields[parentIndex] = mesurePoms;
    }
    setValue(`specPomLibraries[${parentIndex}]`, tmpPomFields[parentIndex]);
    await specPomUpdateLibraries(parentIndex, tmpPomFields[parentIndex]);

    mainSuggestionData.specPomLibraries[parentIndex] = tmpPomFields[parentIndex];
  };

  function callDiffFunction(parentIndex) {
    setTimeout(() => {
      findFractionDiff(parentIndex);
    }, 200);
  }

  const onSelectPomLib = async (val, selectedPomLibArray) => {
    const pomMeasurementData = [...sugPomFracData.pomLibraries];
    if (val === 'selectAll') {
      await pomLibrariesRemove();
      await pomLibrariesAppend([...pomMeasurementData]);
    } else if (val === 'deSelectAll') {
      await pomLibrariesRemove();
    } else {
      if (pomLibrariesFields?.length >= 0 && val.length > 0) {
        const newItem = val.filter((b) => !selectedPomLibArray.some((a) => a.value === b.value));

        if (newItem.length) {
          const results = pomMeasurementData.filter((elem) => newItem.find((el) => elem.code === el.value));
          if (results.length) await pomLibrariesAppend(...results);
        }
      }

      if (val.length < pomLibrariesFields.length) {
        const removeLib = await pomLibrariesFields.filter((elem) => !val.find((el) => elem.code === el.value));
        const findIndex = await pomLibrariesFields.findIndex((pomField) => removeLib[0].code === pomField.code);
        await pomLibrariesRemove(findIndex);
      }
    }
  };

  const onSelectSpecPomLib = async (val, selectedPomLibArray) => {
    const specPomMeasurementData = [...sugFracData.specPomLibraries];

    if (val === 'selectAll') {
      await specPomLibrarieRemove();
      await specPomLibrariesAppend([...specPomMeasurementData]);
    } else if (val === 'deSelectAll') {
      await specPomLibrarieRemove();
    } else {
      if (specPomLibrariesFields?.length >= 0 && val.length > 0) {
        const newItem = val.filter((b) => !selectedPomLibArray.some((a) => a.value === b.value));
        if (newItem.length) {
          const results = specPomMeasurementData.filter((elem) => newItem.find((el) => elem.code === el.value));
          await specPomLibrariesAppend(...results);
        }
      }

      if (val.length < specPomLibrariesFields.length) {
        const removeLib = await specPomLibrariesFields.filter((elem) => !val.find((el) => elem.code === el.value));
        const findIndex = await specPomLibrariesFields.findIndex((pomField) => removeLib[0].code === pomField.code);
        await specPomLibrarieRemove(findIndex);
      }
    }
  };

  const componentCleanup = async () => {
    if (uploadedImg.length > 0) {
      const res = await unlinkUploadImage({ images: uploadedImg });
      if (res) {
        setUploadedImg([]);
      }
    }
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      componentCleanup().catch(console.error);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []); // Empty dependency array ensures this runs only on mount and unmount

  const savedUploadedImage = async (val) => {
    setUploadedImg([...uploadedImg, val.image, val.fullImage]);
  };
  const delateUploadedImage = async (val) => {
    const newArray = uploadedImg.filter((item) => !val.includes(item));
    setUploadedImg(newArray);
  };

  const handleClickToggle = (eventKey) => {
    const copyaccodionArray = comState.accodionArray;
    const accIndex = copyaccodionArray.indexOf(eventKey);
    if (accIndex >= 0) {
      copyaccodionArray.splice(accIndex, 1);
    } else copyaccodionArray.push(eventKey);
    setState((prevState) => ({
      ...prevState,
      accodionArray: copyaccodionArray,
    }));
  };

  const checkAccodionActiveState = (str) => comState.accodionArray.includes(str);

  const contextValue = useMemo(
    () => ({
      measurementSuggestion,
      sugFracData,
      sugPomFracData,
      showGrading,
      conversationData,
      onSelectPomLib,
      onSelectSpecPomLib,
      callDiffFunction,
      findFractionDiff,
    }),
    [measurementSuggestion, sugFracData, sugPomFracData, showGrading, conversationData, onSelectPomLib, onSelectSpecPomLib, callDiffFunction, findFractionDiff],
  );

  return (
    <div className="container-fluid">
      <Row>
        <Col lg={{ span: 3, offset: 9 }}>
          <div className="unit-section">
            <p className="mr-1 ml-3">{t('MESUREMENT.MESUREMENT_UNIT')}</p>
            {conversationData?.conversionType}
          </div>
        </Col>
      </Row>
      <div className="collapse-card">
        <MeasurementDataProvider.Provider value={contextValue}>
          <Accordion activeKey={checkAccodionActiveState('otherFile')}>
            <SpecPomLibraries
              isExisting={showGrading}
              savedUploadedImage={savedUploadedImage}
              delateUploadedImage={delateUploadedImage}
              checkAccodionActiveState={checkAccodionActiveState}
              handleClickToggle={handleClickToggle}
              editModeData={comState.editModeData}
              loading={isLoadingSpecPomLib}
            />
          </Accordion>
        </MeasurementDataProvider.Provider>
      </div>
    </div>
  );
}

const mapStateToProps = ({ UserDetails }) => {
  const { userInfo } = UserDetails;
  return {
    userInfo,
  };
};

const mapStateToDispatch = {
  getHideShowGrading,
  unlinkUploadImage,
  updateMeasurementSuggestion,
};

export default connect(mapStateToProps, mapStateToDispatch)(MeasurementForm);
